import { Button } from "@commonlibs";
import styled, { css } from "styled-components";

export const SuffixTextButton = styled(Button).attrs({ variant: "text" })(
    () => css`
        &&&& {
            padding: 0;
            &:hover {
                background-color: transparent;
            }
        }
    `,
);
